import type { CoreApiClient } from "../client";
import { createHeatingNetworkMutations } from "../mutations/heating-network.mutations";
import { createHeatingNetworkQueries } from "../queries/heating-network.queries";

export const createHeatingNetworkRepository = (api: CoreApiClient) => ({
  ...createHeatingNetworkQueries(api),
  ...createHeatingNetworkMutations(api),
});
